import { HttpTimeout } from '@aex/ngx-toolbox';
import { ConfigString, env } from '@aex/shared/common-lib';

export const environment = env({
  name: ConfigString.Stage,
  mocksEnabled: false,
  httpTimeout: HttpTimeout.SHORT,
  configName: ConfigString.Stage,
});
